// extracted by mini-css-extract-plugin
export default {"table":"IncidentsTab_table__+5LPf","smallBtn":"IncidentsTab_smallBtn__zheOM"};